import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from "@angular/router";
import {Injectable} from "@angular/core";
import {AppEventBus} from "../event-buses/app.event-bus";
import {AppEvent} from "../event-buses/AppEvent";
import {AppEventName} from "../event-buses/AppEventName";

@Injectable()
export class RouterNotificationGuard implements CanActivate {

  constructor(private appEventBus: AppEventBus) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const routeData = route.data;
    const url = state.url;

    this.appEventBus.dispatch(new AppEvent(AppEventName.NavigationData, {url: url, routeData: routeData}));

    // Always return true because this is not a real guard.
    return true;
  }
}
